import { EInternetStatus, EInternetStatusActionTypes } from '../../actions/internetStatus';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function internetStatusReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EInternetStatusActionTypes.Set:
      if (action.payload === EInternetStatus.Online) {
        return {
          ...state,
          internetStatus: action.payload,
        };
      }

      return {
        ...state,
        internetStatus: action.payload,
      };
    default:
      return state;
  }
}
